<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";

    export let providerId = 0;

    let title =  providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";
    
    let MSAuthLink = "";
    let GoogleAuthLink = "";

    onMount(async () => {
        if (providerId == 3) 
            await MSAuth();
        else if (providerId == 1)
            await GetGoogleLink();
    });

    const MSAuth = async () => {
        let resp = await wrappedFetch(`/api/cloud/getAuthLinkMS`, {
            method: "post",
        });
        
        MSAuthLink = await resp.text();         
    };

    const GetGoogleLink = async () => {
        let resp = await wrappedFetch(`/api/cloud/GetAuthLinkGoogle`, {
            method: "post",
        });
        
        GoogleAuthLink = await resp.text();
    }
</script>

<div class="card">
    <div class="card-header">
        <h3>Instructions</h3>
    </div>
    <div class="card-body">
        <p>We need authorisation to sync your data into your school’s {title} tenancy. This is achieved by logging in with a {title} account, that has the appropriate permissions, and granting access. </p> 

        {#if (providerId == 1)}
            <p>We would suggest creating a new account in {title} for this purpose and giving it “super administrator” permissions. Creating a new account ensures that any changes made by the sync are easily identifiable in your admin console’s logs. </p> 
        {/if}
        {#if (providerId == 3) }
            <p>We would suggest creating a new account in {title} for this purpose and giving it 'Global admin' permissions. Creating a new account ensures that any changes made by the sync are easily identifiable in your admin console’s logs.</p>
        {/if}

        <p>Once you have created an account, please log in below and follow the on-screen prompts. If you need any assistance with creating a {title} account or granting permissions, please reach out to our support team. </p> 
        
        {#if providerId == 1}
            <a class="btn btn-primary" href="{GoogleAuthLink}">Log in with Google</a>
        {:else}
            <a class="btn btn-primary" href="{MSAuthLink}">Log in with Microsoft</a>
        {/if}    
    </div>
</div>